import "./DividendPayoutChartComponent.scss";
import template from "./DividendPayoutChartComponent.html";
import {IComponentOptions, IFilterService, IRootElementService} from "angular";
import {DividendsModel} from "../../../../../dividends/models/DividendsModel";
import DividendPayoutChartOptions from "./options/DividendPayoutChartOptions";
import {Dividends} from "../../../../../dividends/types/DividendsRecord";
import {DividendPayoutChartData, DividendPayoutChartDataPoint} from "./types/DividendPayoutChartData";
import {formatDate} from "../../../../../js/util/DateTimeUtil";
import {ArrayUtil} from "../../../../../js/util/ArrayUtil";
import {DividendYearSummary} from "./types/DividendYearSummary";
import {sum} from "../../../../../js/util/UtilFunctions";

export const DividendPayoutChart = "tfDividendPayoutChart";

export function dividendPayoutChart(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<dividends"
        },
        controllerAs: "ctrl",
        controller: DividendPayoutChartComponentController
    };
}

export class DividendPayoutChartComponentController {

    /** @input */
    public set model(model: DividendsModel | null) {
        if (model != null) {
            this.chartData = this.buildChartData(model.dividends);
        }
    }

    public chartData: DividendPayoutChartData;

    public readonly chartOptions = DividendPayoutChartOptions();
    private readonly translateFilter: (value: string) => string;

    /** @ngInject */
    public constructor(private $filter: IFilterService) {
        this.translateFilter = this.$filter("translate");
    }

    private buildChartData(dividends: Dividends): DividendPayoutChartData {
        const dividendsByYear = ArrayUtil.mapBy(dividends, (d) => formatDate(d.exDate, "YYYY"));
        const dividendYearTotals = Array.from(dividendsByYear.entries())
                                        .map(([year, divs]) => this.createYearTotal(year, divs));
        const dps = this.dpsValues(dividendYearTotals);
        const credit = this.creditValues(dividendYearTotals);
        const dpsSeries = {
            key: this.translateFilter("dividends.DPS"),
            color: "rgb(31, 119, 180)",
            values: dps
        };
        const creditSeries = {
            key: this.translateFilter("dividends.FRANKING_CREDIT"),
            color: "rgb(214, 39, 40)",
            values: credit
        };
        return [dpsSeries, creditSeries];
    }

    private createYearTotal(year: string, dividends: Dividends): DividendYearSummary {
        const dps = dividends.map((d) => d.value).reduce(sum, 0);
        const credit = dividends.map((d) => d.value * 0.3 * d.frankingRate).reduce(sum, 0);
        return {
            year,
            dps,
            credit
        };
    }

    private dpsValues(dividends: ReadonlyArray<DividendYearSummary>): ReadonlyArray<DividendPayoutChartDataPoint> {
        return dividends.map((d) => [d.year, d.dps, d.year]);
    }

    private creditValues(dividends: ReadonlyArray<DividendYearSummary>): ReadonlyArray<DividendPayoutChartDataPoint> {
        return dividends.map((d) => [d.year, d.credit, d.year]);
    }
}
